<template>
  <div class="Footer">
    <template v-if="isMobile(true)">
        <b-navbar toggleable="lg" type="dark" variant="info" class="container footerSecMob">
            <b-row>
                <b-col sm='6'>
                    <b-navbar-brand href="#">
                        <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/01/60463242f5efbb3130100fab_ImSim_Logotipo_Principal_2-p-500.png"></b-img>
                        <span class="FooterUK">UK Distributer</span>
                    </b-navbar-brand>
                </b-col>
                <b-col sm='6'>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item class="navItems" href="#about" right>© {{ new Date().getFullYear() }} Showroom located in East Sussex, UK</b-nav-item>
                    </b-navbar-nav>
                </b-col>
            </b-row>
        </b-navbar>
    </template>
    <template v-else>
        <b-navbar toggleable="lg" type="dark" variant="info" class="container">
            <b-navbar-brand href="#">
                <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/01/60463242f5efbb3130100fab_ImSim_Logotipo_Principal_2-p-500.png"></b-img>
                <span class="FooterUK">UK Distributer</span>
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="navItems foot textGolf" href="#about" right>© {{ new Date().getFullYear() }} Showroom located in East Sussex, UK</b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </template>

  </div>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        isMobile() {
            if( screen.width <= 500 ) {
                return true;
            }
            else {
                return false;
            }
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* .socialIconFace > a {
    padding-right: 0px;
} */
 span.FooterUK {
    font-style: italic;
    font-size: 16px;
    font-weight: bold;
    position: relative;
    top: 2px;
}
li.nav-item.navItems.foot.socialIconFace {
    margin-right: 0;
}
.textGolf {
    margin-top: 8px;
}
img.socialIcons {
    width: 30px;
}
::v-deep .btn-danger {
    color: #fff;
    background-color: #7ebd63;
    border-color: #7ebd63!important;
}
li.nav-item.navItems.foot > a:hover {
    color: #fff;
}
.wereConnected {
    padding-left: 30px;
    padding-left: 30px;
    padding-top: 15px;
}
.navItems {
    font-size: 12px;
}
p.FooterText {
    text-align: left;
    font-size: 12px;
}
h5.connected {
    font-size: 16px;
    text-align: left;
}
.navbar-dark .navbar-nav .nav-link {
    color: #fff;
}
.logo {
    width: 140px;
    height: 55px
}
.bg-info {
    background-color: #000 !important;
}
.Footer {
    background-color: #000;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 8px solid #fe011d;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
@media only screen and (max-width: 1650px) {
  .TopHomeback-Image {
    background-image: url('https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/HeaderImage_OCS_Studios.png');
    background-repeat: no-repeat;
    background-size: contain;
    /* background-size: 100% 100%; */
    height: 75vh;
  }
}
@media only screen and (max-width: 500px) {
    .logo {
        /* padding-bottom: 20px; */
    }
    a.navbar-brand {
        margin-right: 0;
    }
    .wereConnected {
        padding-left: 0px;
        padding-left: 0px;
        padding-top: 15px;
    }
    .navItems {
        font-size: 12px;
    }
    p.FooterText {
        text-align: center;
        font-size: 12px;
    }
    h5.connected {
        font-size: 16px;
        text-align: center;
    }
}
</style>
